export const activateCustomerSubscription = `
    mutation activateCustomerSubscription($id: ID!) {
        activateCustomerSubscription(id: $id) {
            id
            customerId
            status
            updated
        }
    }
`;

export const cancelCustomerSubscription = `
    mutation cancelCustomerSubscription($id: ID!) {
        cancelCustomerSubscription(id: $id) {
            id
            customerId
            status
            updated
        }
    }
`;

export const createCustomerSubscription = `
    mutation createCustomerSubscription($input: CreateCustomerSubscriptionInput!) {
        createCustomerSubscription(input:$input) {
            id
            customerId
            customer {
                id
                name
            }
            status
            created
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            updated  
    }
}`;

export const updateCustomerSubscription = `
    mutation updateCustomerSubscription($input: UpdateCustomerSubscriptionInput!) {
        updateCustomerSubscription(input:$input){
            id
            customerId
            customer {
                id
                name
            }
            status
            created
            createdByUsername
            createdByUser {
              name
              givenName
              familyName
              email
            }
            updated       
            updatedByUsername
        }
}`;

export const deleteCustomerSubscription = `
    mutation deleteCustomerSubscription($input: DeleteCustomerSubscriptionInput!) {
        deleteCustomerSubscription(input:$input) 
}`;
